import { twMerge } from "tailwind-merge";

export function SVG_LogoBadCat({ className, theme = "#f9a0ae" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="426.471"
      height="76.765"
      viewBox="0 0 426.471 76.765"
      className={twMerge(className)}
    >
      <path
        d="M34.634,75.767c-12.231,0-25.47-3.759-31.285-15.2-6.993-13.785-1.3-25.658,1.5-37.229C7.525,12.253,8.175.544,13.833.017c3.232-.3,6.57,3.578,8.112,5.1,0,0,5.719,6.469,12.521,6.469h.384c6.807,0,12.529-6.469,12.529-6.469,1.544-1.526,4.882-5.408,8.106-5.1,5.658.527,6.313,12.236,8.986,23.322,2.791,11.571,8.5,23.444,1.49,37.229-5.8,11.44-19.043,15.2-31.279,15.2ZM11.08,47.161a23.579,23.579,0,1,0,23.586-23.53A23.556,23.556,0,0,0,11.08,47.161Zm298.3,7.066a21.045,21.045,0,0,1,7.954-16.476,18.884,18.884,0,1,1,9.616-4.3,20.94,20.94,0,0,1,11.276,1.192V11.94A11.394,11.394,0,0,1,349.624.547h5.1a5.283,5.283,0,0,1,5.354,4.983,5.141,5.141,0,0,1-5.138,5.3h-3.288a3.153,3.153,0,0,0-3.144,3.144v2.433h6.673a5.142,5.142,0,0,1,0,10.283H348.51V43.352a21.076,21.076,0,1,1-39.128,10.875Zm10.283,0a10.8,10.8,0,1,0,10.8-10.8A10.808,10.808,0,0,0,319.664,54.227ZM306.194,19.078a8.57,8.57,0,1,0,8.57-8.571A8.58,8.58,0,0,0,306.194,19.078ZM175.338,75.013a11.4,11.4,0,0,1-11.4-11.4V48.852a5.1,5.1,0,0,1,2.043-9.789h11.683V34.545H172.48A11.748,11.748,0,0,1,160.732,22.8V13.3a11.4,11.4,0,0,1,11.4-11.4h23.336a5.284,5.284,0,0,1,5.354,4.983,5.141,5.141,0,0,1-5.139,5.3H174.158a3.152,3.152,0,0,0-3.143,3.144v5.791a3.152,3.152,0,0,0,3.143,3.144h21.307a5.284,5.284,0,0,1,5.354,4.983,5.141,5.141,0,0,1-5.139,5.3h-7.732v4.518h16.793a3.154,3.154,0,0,0,3.144-3.144V6.514a5.283,5.283,0,0,1,4.983-5.354,5.141,5.141,0,0,1,5.3,5.138V37.949a11.4,11.4,0,0,1-11.4,11.4H174.224V61.587a3.153,3.153,0,0,0,3.144,3.144h32.345a5.284,5.284,0,0,1,5.354,4.983,5.141,5.141,0,0,1-5.139,5.3Zm-39-1.522L119.334,56.344,104.451,73.266a5.141,5.141,0,0,1-7.721-6.791l17.291-19.66H96.492a5.141,5.141,0,0,1,0-10.282H115.15V34.008h-6.46A11.76,11.76,0,0,1,96.943,22.262v-9.5a11.41,11.41,0,0,1,11.4-11.4h23.552a11.761,11.761,0,0,1,11.747,11.748v9.149a11.76,11.76,0,0,1-11.747,11.747h-6.459v2.525h18.657a5.141,5.141,0,0,1,0,10.282H127.714L126.14,48.6l17.5,17.646a5.141,5.141,0,1,1-7.3,7.241Zm-29.115-58.7v5.791a3.144,3.144,0,0,0,3.144,3.144h19.843a3.145,3.145,0,0,0,3.145-3.144V14.792a3.144,3.144,0,0,0-3.145-3.144H110.369A3.143,3.143,0,0,0,107.225,14.792ZM415.193,52.815V5.217a5.141,5.141,0,0,1,10.283,0v47.6a5.141,5.141,0,0,1-10.283,0Zm-180,4.774a5.141,5.141,0,0,1,0-10.283h15.385c0-.036-.005-.072-.005-.108V39.471a5.142,5.142,0,0,1,10.283,0V47.2c0,.036-.005.072-.005.108h12.431c0-.048-.008-.094-.008-.141V15.325a3.151,3.151,0,0,0-3.144-3.143H237.051A5.284,5.284,0,0,1,231.7,7.2a5.141,5.141,0,0,1,5.138-5.3H272.16a11.4,11.4,0,0,1,11.4,11.4v34.01h.176a5.141,5.141,0,0,1,0,10.283ZM368.656,21.547a21.078,21.078,0,1,1,21.078,21.079A21.1,21.1,0,0,1,368.656,21.547Zm10.283,0a10.8,10.8,0,1,0,10.8-10.8A10.808,10.808,0,0,0,378.939,21.547Z"
        transform="translate(0.496 0.497)"
        fill={theme}
        stroke="rgba(0,0,0,0)"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </svg>
  );
}

export function SVG_LogoNCat({ className, theme = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="154.501"
      height="31.247"
      viewBox="0 0 154.501 31.247"
      className={twMerge(className)}
    >
      <path
        d="M558.036,47.265a2.977,2.977,0,0,1-2.665-1.646L545.709,26.3a2.977,2.977,0,0,1,5.325-2.663L560.7,42.956a2.978,2.978,0,0,1-2.66,4.309"
        transform="translate(-430.701 -17.364)"
        fill={theme}
        className="transition-colors"
      />
      <path
        d="M211.692,48.2a2.977,2.977,0,0,1-2.977-2.977V32.05a2.762,2.762,0,0,0-2.759-2.759h-7.44a2.762,2.762,0,0,0-2.759,2.759V45.224a2.977,2.977,0,1,1-5.954,0V32.05a8.723,8.723,0,0,1,8.713-8.713h7.44a8.723,8.723,0,0,1,8.714,8.713V45.224a2.977,2.977,0,0,1-2.977,2.977"
        transform="translate(-149.887 -18.43)"
        fill={theme}
        className="transition-colors"
      />
      <path
        d="M397.576,48.427h-7.26a8.813,8.813,0,0,1-8.8-8.8v-7.26a8.813,8.813,0,0,1,8.8-8.8h7.26a8.813,8.813,0,0,1,8.8,8.8,2.977,2.977,0,0,1-5.954,0,2.852,2.852,0,0,0-2.849-2.849h-7.26a2.852,2.852,0,0,0-2.849,2.849v7.26a2.852,2.852,0,0,0,2.849,2.849h7.26a2.977,2.977,0,1,1,0,5.954"
        transform="translate(-301.282 -18.605)"
        fill={theme}
        className="transition-colors"
      />
      <path
        d="M640.148,23.849H621.526a2.892,2.892,0,1,0,0,5.783h6.346c-.006.078-.012.156-.012.236V45.629a2.977,2.977,0,1,0,5.954,0V29.868c0-.08-.006-.158-.012-.236h6.346a2.892,2.892,0,1,0,0-5.783"
        transform="translate(-488.539 -18.834)"
        fill={theme}
        className="transition-colors"
      />
      <path
        d="M339.143,117.092a2.884,2.884,0,1,1-2.884-2.884,2.884,2.884,0,0,1,2.884,2.884"
        transform="translate(-263.269 -90.19)"
        fill={theme}
        className="transition-colors"
      />
      <path
        d="M502.42,90a2.977,2.977,0,0,0,2.665-1.646l3.894-7.942a2.977,2.977,0,0,0-5.325-2.663l-3.894,7.942A2.978,2.978,0,0,0,502.42,90"
        transform="translate(-394.415 -60.101)"
        fill={theme}
        className="transition-colors"
      />
      <path
        d="M26.588,9.625c-1.1-4.572-1.372-9.4-3.706-9.618-1.329-.125-2.706,1.475-3.343,2.105,0,0-2.36,2.668-5.167,2.668h-.159c-2.8,0-5.164-2.668-5.164-2.668C8.414,1.482,7.037-.118,5.7.007,3.371.224,3.1,5.053,2,9.625.844,14.4-1.5,19.293,1.381,24.978c2.4,4.718,7.858,6.269,12.9,6.269h.02c5.046,0,10.508-1.551,12.9-6.269,2.892-5.685.536-10.582-.615-15.353M14.3,29.149a9.7,9.7,0,1,1,9.721-9.7,9.715,9.715,0,0,1-9.721,9.7"
        transform="translate(0 0)"
        fill={theme}
        className="transition-colors"
      />
    </svg>
  );
}

export function SVG_Play({ className, theme = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      className={twMerge(className)}
    >
      <g fill="none" stroke={theme} strokeWidth="1" className="transition-colors">
        <circle cx="19" cy="19" r="19" stroke="none" />
        <circle cx="19" cy="19" r="18.5" fill="none" />
      </g>
      <path
        d="M9.918,0l9.918,14.87H0Z"
        transform="translate(29.016 9.082) rotate(90)"
        fill={theme}
        className="transition-colors"
      />
    </svg>
  );
}

export function SVG_Pause({ className, theme = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      className={twMerge(className)}
    >
      <g fill="none" stroke={theme} strokeWidth="1" className="transition-colors">
        <circle cx="19" cy="19" r="19" stroke="none" />
        <circle cx="19" cy="19" r="18.5" fill="none" />
      </g>
      <rect
        width="6"
        height="14"
        transform="translate(12 12)"
        fill={theme}
        className="transition-colors"
      />
      <rect
        width="6"
        height="14"
        transform="translate(20 12)"
        fill={theme}
        className="transition-colors"
      />
    </svg>
  );
}

export function SVG_Hamburger({ className, theme = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35.349"
      height="27"
      viewBox="0 0 35.349 27"
      className={twMerge(className)}
    >
      <path
        d="M-3180.384-15456.589h35.349"
        transform="translate(3180.384 15458.089)"
        fill="none"
        stroke={theme}
        strokeWidth="3"
        className="transition-colors"
      />
      <path
        d="M-3180.384-15456.589h35.349"
        transform="translate(3180.384 15470.089)"
        fill="none"
        stroke={theme}
        strokeWidth="3"
        className="transition-colors"
      />
      <path
        d="M-3180.384-15456.589h35.349"
        transform="translate(3180.384 15482.089)"
        fill="none"
        stroke={theme}
        strokeWidth="3"
        className="transition-colors"
      />
    </svg>
  );
}

export function SVG_PrevArrow({ className, theme = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.862"
      height="24.2"
      viewBox="0 0 17.862 24.2"
      className={twMerge(className)}
    >
      <path
        d="M-4962.2-15815.567l-13.265,10.3,13.265,9.7"
        transform="translate(4977.959 15817.672)"
        fill="none"
        stroke={theme}
        strokeLinecap="round"
        strokeWidth="3"
        className="transition-colors"
      />
    </svg>
  );
}

export function SVG_NextArrow({ className, theme = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.862"
      height="24.2"
      viewBox="0 0 17.862 24.2"
      className={twMerge(className)}
    >
      <path
        d="M-4975.466-15815.567l13.265,10.3-13.265,9.7"
        transform="translate(4977.571 15817.672)"
        fill="none"
        stroke={theme}
        strokeLinecap="round"
        strokeWidth="3"
        className="transition-colors"
      />
    </svg>
  );
}
